import React from 'react';
import { ButtonGroup } from '@tencent/spaui';
import { roleTarget } from '../setting/clue/config';

export const SwitchEmployeeGroup = (props) => {
  return (
    <ButtonGroup
      className="scope-switch"
      ButtonProps={{ size: 'small' }}
      data={Object.keys(roleTarget).map((key) => ({
        value: key,
        label: roleTarget[key],
      }))}
      disabled={!!props.disabled}
      value={props.target || 'USER'}
      onChange={(event, value, buttonProps) => {
        props.setTarget(value);
      }}
    />
  );
};
